// extracted by mini-css-extract-plugin
export default {"upload-content":"FileUpload_upload-content__C0kZj","upload-label":"FileUpload_upload-label__qCEa4"};